var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkTheme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 41.125C18.6042 41.125 14.4427 39.4115 11.0156 35.9844C7.58854 32.5573 5.875 28.3958 5.875 23.5C5.875 18.6042 7.58854 14.4427 11.0156 11.0156C14.4427 7.58854 18.6042 5.875 23.5 5.875C23.9569 5.875 24.4061 5.89132 24.8473 5.92396C25.2886 5.9566 25.7208 6.00556 26.1438 6.07083C24.8056 7.01736 23.7363 8.24981 22.936 9.76817C22.1357 11.2865 21.7362 12.9263 21.7375 14.6875C21.7375 17.625 22.7656 20.1219 24.8219 22.1781C26.8781 24.2344 29.375 25.2625 32.3125 25.2625C34.1076 25.2625 35.7559 24.8623 37.2573 24.062C38.7587 23.2617 39.9826 22.1931 40.9292 20.8562C40.9944 21.2806 41.0434 21.7127 41.076 22.1527C41.1087 22.5926 41.125 23.0418 41.125 23.5C41.125 28.3958 39.4115 32.5573 35.9844 35.9844C32.5573 39.4115 28.3958 41.125 23.5 41.125Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTheme);
export default __webpack_public_path__ + "static/media/darkTheme.994c398c4e9015d33687c1d2379c5bad.svg";
export { ForwardRef as ReactComponent };